export default __webpack_public_path__ + "static/cruiselines-vv-ship-4-4e2ff70586d9f33fdf32cf30a7b7fbcc.jpg";